module.exports = __webpack_public_path__ + "static/template_options_2_months-4c5fcbf74d09ccbabcff6a199aee9596.png";